import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { userProfileReselector as stateSelector } from 'reduxModules/users/selectors'
import { profileDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import { connect } from 'react-redux'
import '../../generic/RenderedField/styles.css'

export function Profile({
  loadUserProfile,
  onSubmit,
  initialValues,
  cancel
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    defaultValues: initialValues
  })

  useEffect(() => {
    loadUserProfile()
  }, [loadUserProfile])

  useEffect(() => {
    if (initialValues) reset(initialValues)
  }, [initialValues, reset])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="input-group">
        <div className={classnames('field', { '-error': errors.firstName })}>
          <div className="field-container">
            <input
              {...register('firstName', {
                required: 'This field is required.'
              })}
              type="text"
              placeholder="First Name"
              aria-label="First Name"
            />
            <span
              className={`field__error${!errors.firstName ? ' field__error--hidden' : ''}`}
              role="alert"
            >
              {errors.firstName?.message}
            </span>
          </div>
        </div>
      </div>
      <div className="input-group">
        <div className={classnames('field', { '-error': errors.lastName })}>
          <div className="field-container">
            <input
              {...register('lastName', {
                required: 'This field is required.'
              })}
              type="text"
              placeholder="Last Name"
              aria-label="Last Name"
            />
            <span
              className={`field__error${!errors.lastName ? ' field__error--hidden' : ''}`}
              role="alert"
            >
              {errors.lastName?.message}
            </span>
          </div>
        </div>
      </div>
      <div
        className="buttons"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <button
          className="btn -mini -blue-2"
          type="button"
          onClick={() => cancel()}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="submit-btn btn -orange -mini"
          disabled={!isDirty || isSubmitting}
          style={{ width: 140, marginLeft: 20 }}
        >
          Save changes
        </button>
      </div>
    </form>
  )
}

Profile.propTypes = {
  loadUserProfile: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.objectOf(PropTypes.string),
  cancel: PropTypes.func.isRequired
}

export default connect(stateSelector, dispatchSelector)(Profile)
